// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseURL: 'http://dpapitest.antimtechnologies.com/',
  imageURL: 'http://dpapitest.antimtechnologies.com/PH/',
  galleryURL: 'http://dpapitest.antimtechnologies.com/PH/GALLERY/',
  firebaseConfig: {
    apiKey: "AIzaSyAZw9AdIwJsZZsU0Ef54YPJRTJt0EtsQD0",
    authDomain: "dhadukparivar-75906.firebaseapp.com",
    projectId: "dhadukparivar-75906",
    storageBucket: "dhadukparivar-75906.firebasestorage.app",
    messagingSenderId: "33667738449",
    appId: "1:33667738449:web:e963a1643a0a07e51a0170",
    measurementId: "G-9HJ5V5Y2K4",
    // vapidKey: "BNFp3xKrdCrBfnyl4MrDJxN5lXoJO74EAbsDCjSg6sFE8YagiEuTxYIcMz3AnjpAYkxN7t_a4h3sBOJdhZthEuo"
  },
  anprUrl: "https://anprapi.antimgps.com/",
  // schoolURL: 'http://192.168.1.19:3000/api/v1',
  schoolURL: 'https://testapi.antimgps.com/api/v1'
};